// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
    production: false,
    backendBaseUrl: 'http://localhost:5000/',
    backendApiUrl: 'http://localhost:5000/api/v2.0/',
    firebaseConfig: {
        apiKey: "AIzaSyAHiOMrg2wtuaX-h30ig_CEtuBVRAoNw5g",
        authDomain: "gigwizer-dev.firebaseapp.com",
        databaseURL: "https://gigwizer-dev.firebaseio.com",
        projectId: "gigwizer-dev",
        storageBucket: "gigwizer-dev.appspot.com",
        messagingSenderId: "9381750385"
    },
    stripeConfig: {
      clientId: "ca_CoeUMYqNQ5ZqL09seSV77C3oIQV3Uk6Q", // TEST MODE !
      authorizeUrl: "https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_CoeUMYqNQ5ZqL09seSV77C3oIQV3Uk6Q&scope=read_write&state=mycustomtoken213879312" // TEST MODE !
    }
};

// export const environment = {
//     production: true,
//     backendBaseUrl: 'https://api.gigwizer.com/',
//     backendApiUrl: 'https://api.gigwizer.com/api/v2.0/',
//     firebaseConfig: {
//         apiKey: "AIzaSyBYJ7MeMwIbYYFRJDeobnZwJH4y4qEC00s",
//         authDomain: "gigwizer-785db.firebaseapp.com",
//         databaseURL: "https://gigwizer-785db.firebaseio.com",
//         projectId: "gigwizer-785db",
//         storageBucket: "gigwizer-785db.appspot.com",
//         messagingSenderId: "208855589694"
//     }
// };




// WEBPACK FOOTER //
// ./src/environments/environment.ts